import styled from "styled-components";
import {JackpotBetWidgetGamesListContainerDefaultBox} from "./jackpot-bet-widget-games-list-container.default.box";
import {baseColors} from "../../../../themes/definitions/casino777/base-colors";

export const JackpotBetWidgetGamesListContainer777Box = styled(JackpotBetWidgetGamesListContainerDefaultBox)`
  background:${baseColors.base05Contrast};

  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  padding-bottom: 1rem;
  padding-top: 1rem;

  @media ${({theme}) => theme.mediaQuery.sExact} {
    padding-top: 2.5rem;
  }
`;
